
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip-paper-stock)","fill":"#838383"}},[_c('path',{attrs:{"d":"M7.466 14.973h9.067v1.893H7.466v-1.893zM7.466 20.303h9.067v1.694H7.466v-1.694zM7.466 17.663h9.067v1.843H7.466v-1.843zM7.466 12.282h9.067v1.893H7.466v-1.893z"}}),_c('path',{attrs:{"d":"M23.832 10.444l-11.584-8.29a.397.397 0 00-.463 0L.167 10.444a.4.4 0 00.23.727.393.393 0 00.228-.075L3.68 8.92v13.078h2.99V11.874a.39.39 0 01.398-.389h9.865a.389.389 0 01.398.389v10.123h2.99V8.91l3.048 2.183a.4.4 0 00.626-.391.394.394 0 00-.162-.257z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip-paper-stock"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h24v24H0z"}})])])])
          )
        }
      }
    